import React from "react";
import Profile from "../Cards/Profile/Profile";

function MyProfilePage() {
  return <Profile />;
}

export default MyProfilePage;
